import { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5006';
const iniciais = (nome) => (nome || '').split(/\s+/).filter(Boolean).slice(0, 2).map(s => s[0]).join('').toUpperCase();

// Avatar do funcionário — reusa o endpoint de foto (arquivo local do RH + fallback Drive).
// Sem foto (ou erro) → iniciais.
export default function AvatarFunc({ id, nome, temFoto, token, size = 40 }) {
  const [erro, setErro] = useState(false);
  const estilo = { width: size, height: size };
  if (!temFoto || erro) {
    return <span className="avatar-func avatar-func--ini" style={{ ...estilo, fontSize: Math.round(size * 0.36) }}>{iniciais(nome)}</span>;
  }
  return (
    <img
      className="avatar-func"
      style={estilo}
      loading="lazy"
      alt=""
      src={`${API_URL}/organograma/foto/${id}?t=${token}`}
      onError={() => setErro(true)}
    />
  );
}
